import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usePermissions } from '@/app/hooks/usePermissions';
import { loadJourney } from '@/modules/journey/actions/async/load-journey';
import { getJourney } from '@/modules/journey/store/selectors';
import { AppDispatch } from '@/root-store';

import { View } from './view';

interface IProps {
  journeyId: string;
  onNavigateBack: (uri: string) => void;
}

const Details = ({ journeyId, onNavigateBack }: IProps) => {
  const dispatch: AppDispatch = useDispatch();

  usePermissions('viewJourney');

  useEffect(() => {
    dispatch(loadJourney({ id: journeyId }));
  }, [dispatch, journeyId]);

  const journey = useSelector(getJourney);

  const handleClickBack = useCallback(async () => {
    onNavigateBack('/journeys');
  }, [onNavigateBack]);

  if (!journey) {
    return null;
  }

  return <View journey={journey} onClickBack={handleClickBack} />;
};

export { Details };
